<!--<app-cookie-policy-banner></app-cookie-policy-banner>-->
<div class="header-wrapper">
  <div class="lines">
    <div class="blue-line"></div>
    <div class="green-line"></div>
  </div>
  <header>
    <div class="header-top layout-fluid-constrained layout-align-center layout-mb-10">
      <a href="/" class="logo">
        <span class="logo-mark" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 30 30" fill="none"><path d="M3 18c6-2 10-1 14 1 4-8 8-11 10-12-6 0-16 2-24 11z" fill="#8fc043"></path><path d="M3 18c8-5 17-7 24-11-8 8-16 12-24 11z" fill="#1e95d4"></path></svg>
        </span>
        <span class="logo-text">Мини Заем</span>
      </a>

      <div class="h-customer">
        @if (!sharedState.isCustomerLogged()) {
          <form [formGroup]="loginForm" class="form-horizontal login-box-form">
            <app-form-element name="email" label="E-mail" type="INPUT"></app-form-element>
            <app-form-element name="password" label="Парола" type="PASSWORD"></app-form-element>
          </form>
          <div class="form-buttons">
            <button class="login-box-submit-button" (click)="login()" type="submit">
              Вход
            </button>
            <a routerLink="/customer/forgotten-password" class="login-box-forgotten-password-link" href="">Забравена парола</a>
          </div>
        } @else {
          <div class="customer-info-wrapper">
            <span class="label layout-mr-5">Профил на</span>
            <span class="name">{{ sharedState.customer()?.name }} {{ sharedState.customer()?.lastName }}</span>

            <div class="c-both"></div>
            <div class="links">
              <a routerLink="/customer/change-password" class="forgotten-pass-link">Смяна на парола</a>
              <span>/</span>
              <a (click)="logout()" class="logout-link">Изход</a>
            </div>
          </div>
        }
        <app-loader [isLoading]="isCustomerPanelLoading"></app-loader>
      </div>
    </div>
    <app-menu></app-menu>
  </header>
</div>
